import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

const INTERVAL_SECONDS = 3;

export default class extends Controller {
  static values = { waited: Number };

  connect() {
    this.timer = setTimeout(() => this.poll(), INTERVAL_SECONDS * 1000);
  }

  disconnect() {
    clearTimeout(this.timer);
  }

  poll() {
    const frame = this.element.closest("turbo-frame[src]");
    const url = new URL(frame ? frame.src : window.location.href);
    url.searchParams.set("waited", this.waitedValue + INTERVAL_SECONDS);
    if (frame) {
      frame.src = url;
    } else {
      Turbo.visit(url, { action: "replace" });
    }
  }
}
